const isIOS = () => !!window.navigator.platform && /iPad|iPhone/.test(window.navigator.platform);

const isMobileDevice = () => {
	const isMobile = {
		Android() {
			return window.navigator.userAgent.match(/Android/i);
		},
		iOS() {
			return window.navigator.userAgent.match(/iPhone|iPad/i);
		},
		Opera() {
			return window.navigator.userAgent.match(/Opera Mini/i);
		},
		Windows() {
			return window.navigator.userAgent.match(/IEMobile/i);
		},
		BlackBerry() {
			return window.navigator.userAgent.match(/BlackBerry/i);
		},
		any() {
			return (
				isMobile.Android() ||
				isMobile.BlackBerry() ||
				isMobile.iOS() ||
				isMobile.Opera() ||
				isMobile.Windows()
			);
		},
	};
	return isMobile.any();
};

const createRedirectLink = (token?: string) => {
	const isChromeOnAppleDevice = Boolean(window.navigator.userAgent.match(/CriOS/));
	const isFirefoxOnAppleDevice = Boolean(window.navigator.userAgent.match(/FxiOS/));
	const isOperaTouchOnAppleDevice = Boolean(window.navigator.userAgent.match(/OPT/));
	const isIosStandalone =
		window.matchMedia("(display-mode: standalone)").matches ||
		(window.navigator as Navigator & { standalone?: boolean }).standalone === true;

	if (isIosStandalone) {
		return `bankid:///?autostarttoken=${token}&redirect=null`;
	}

	if (isChromeOnAppleDevice) {
		return `bankid:///?autostarttoken=${token}&redirect=${encodeURIComponent("googlechrome://")}`;
	}
	if (isFirefoxOnAppleDevice) {
		return `bankid:///?autostarttoken=${token}&redirect=${encodeURIComponent("firefox://")}`;
	}
	if (isOperaTouchOnAppleDevice) {
		return `bankid:///?autostarttoken=${token}&redirect=${encodeURIComponent(
			`${window.location.href.replace("http", "touch-http")}#bankid-${Date.now()}`,
		)}`;
	}

	return `https://app.bankid.com/?autostarttoken=${token}&redirect=${encodeURIComponent(`${window.location.href}#bankid-${Date.now()}`)}`;
};

export const openBankIdApp = (token?: string) => {
	let link = "";
	if (isMobileDevice() && !isIOS()) {
		link = `bankid:///?autostarttoken=${token}&redirect=null`;
	} else if (isIOS()) {
		link = createRedirectLink(token);
	} else {
		link = `bankid:///?autostarttoken=${token}&redirect=null`;
	}

	window.location.href = link;
};
